module.exports = __webpack_public_path__ + "img/arrow-pay.fe070c2c.svg";